import { useBodyClass } from './useBodyClass';

/**
 * Hook to lock body scroll when a modal or overlay is open
 * @param isLocked - Whether the body scroll should be locked
 */
const useBodyScrollLock = (isLocked: boolean) => {
  useBodyClass('modal-open', isLocked);
};

export default useBodyScrollLock;
